var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.907227,
    y: 0.731445,
    width: 61.3728,
    height: 60.8397,
    rx: 11,
    fill: "#25A869"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4157 13.7954H16.7771C14.793 13.7954 13.1846 14.8555 13.1846 16.9311V36.8066C13.1846 38.8823 14.793 40.5649 16.7771 40.5649H46.4157C48.3998 40.5649 50.0083 38.8823 50.0083 36.8066V16.9311C50.0083 14.8555 48.3998 13.7954 46.4157 13.7954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7037 39.9858H30.3452V43.8729H32.7037V39.9858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1691 43.0633C31.6291 42.7032 30.8962 42.844 30.532 43.378C30.1678 43.9119 30.3103 44.6367 30.8502 44.9968L35.7467 48.2628C36.2867 48.6229 37.0196 48.4821 37.3838 47.9481C37.748 47.4142 37.6055 46.6894 37.0656 46.3293L32.1691 43.0633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1347 45.0119C32.6746 44.6517 32.8171 43.927 32.4529 43.393C32.0887 42.8591 31.3557 42.7182 30.8158 43.0784L25.9193 46.3443C25.3793 46.7045 25.2369 47.4293 25.6011 47.9632C25.9653 48.4971 26.6982 48.638 27.2381 48.2779L32.1347 45.0119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7685 16.229H17.4227C16.4374 16.229 15.6387 17.0313 15.6387 18.021V36.3393C15.6387 37.329 16.4374 38.1313 17.4227 38.1313H45.7685C46.7538 38.1313 47.5525 37.329 47.5525 36.3393V18.021C47.5525 17.0313 46.7538 16.229 45.7685 16.229Z",
    fill: "#25A869"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.9716,
    height: 34.7721,
    fill: "white",
    transform: "translate(13.1074 13.7651)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.22e96ecc574e6a331e82793fb7f49aad.svg";
export { ForwardRef as ReactComponent };